import { desktopWidht, mobileWidth } from '../constants';

window.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('.headerButton');
  const burgerIcon = document.querySelector('.headerButton__burger');
  const crossIcon = document.querySelector('.headerButton__cross');
  const header = document.querySelector('.header');
  const navLinks = document.querySelectorAll('.header .navLink');
  const navLinksBox = document.querySelectorAll('.header .navLink__box');

  let isBurgerVisible = true;

  button.addEventListener('click', () => {
    isBurgerVisible = !isBurgerVisible;
    updateIconsVisibility();

    header.classList.toggle('header--menuOpened', !isBurgerVisible);
    document.body.classList.toggle('overflow-y-hidden', !isBurgerVisible);
  });

  function updateIconsVisibility() {
    const blockDisplay = isBurgerVisible ? 'block' : 'none';
    const noneDisplay = isBurgerVisible ? 'none' : 'block';

    burgerIcon.style.display = blockDisplay;
    crossIcon.style.display = noneDisplay;
  }

  const hoveredClass = 'navLink--hovered';
  const subMenuClass = 'subMenu';
  const visibleClass = 'subMenu--visible';

  function handleNavLinkInteraction(navLinksBox) {
    const navLink = navLinksBox.querySelector('.navLink');

    if (navLink.classList.contains(hoveredClass)) {
      navLink.classList.remove(hoveredClass);
      const subMenu = navLink.parentElement.querySelector(`.${subMenuClass}`);
      if (subMenu) {
        subMenu.classList.remove(visibleClass);
      }
    } else {
      navLinks.forEach(otherNavLink => {
        otherNavLink.classList.remove(hoveredClass);
        const otherSubMenu = otherNavLink.parentElement.querySelector(`.${subMenuClass}`);
        if (otherSubMenu) {
          otherSubMenu.classList.remove(visibleClass);
        }
      });

      navLink.classList.add(hoveredClass);
      const subMenu = navLink.parentElement.querySelector(`.${subMenuClass}`);
      if (subMenu) {
        subMenu.classList.add(visibleClass);
      }
    }
  }

  navLinksBox.forEach(navLinkBox => {
    navLinkBox.addEventListener('click', e => {
      if (window.innerWidth < desktopWidht) {
        e.preventDefault();
        handleNavLinkInteraction(navLinkBox);
      }
    });
  });

  const headerScolledClass = 'header--scrolled';
  const headerWhiteClass = 'header--white';
  const isHomePage = document.body.classList.contains('home');
  const isCategoryPage = document.body.classList.contains('category');
  const isCategoriesPage = document.body.classList.contains('categories');

  const setHeaderClassByDefault = () => {
    if (!isHomePage && !isCategoryPage && !isCategoriesPage) {
      header.classList.add(headerWhiteClass);
    }
  };

  if (isHomePage || isCategoryPage || isCategoriesPage) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 5) {
        header.classList.add(headerScolledClass);
      } else {
        header.classList.remove(headerScolledClass);
      }
    });
  }

  setHeaderClassByDefault();
});
